import { render } from "./HoliDaysPage.vue?vue&type=template&id=376d230a&scoped=true"
import script from "./HoliDaysPage.vue?vue&type=script&lang=js"
export * from "./HoliDaysPage.vue?vue&type=script&lang=js"

import "./HoliDaysPage.vue?vue&type=style&index=0&id=376d230a&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376d230a"]])

export default __exports__